import { Action } from '@ngrx/store';

export enum EPackageSummaryActions {
  GetPackageSummary = '[Package visualizer] Get the package summary of the bex from server',
  GetPackageSummarySuccess = '[Package visualizer] Get the package summary of the bex from server success',
  GetPackageSummaryFailure = '[Package visualizer] Get the package summary of the bex from server failure',
  SetSelectedCatalogObjects = '[Package visualizer] set selected list of catalog objects',
  SetSelectedCatalogObjectsSuccess = '[Package visualizer] set selected list of catalog objects success',
  SearchPackageSummary = '[Package visualizer] Search inside the package summary',
  FilterPackageSummary = '[Package visualizer] Filter inside the package summary',
  SearchAndFilterPackageSummary = '[Package visualizer] Filter inside the package summary',
  SetSearchText = '[Package visualizer] Set the text to search the package summary',
  SetSelectedFilters = '[Package visualizer] Set the types to filter the package summary',
  GetDependencies = '[Package visualizer] Get Object dependencies',
  GetDependenciesSuccess = '[Package visualizer] Get Object dependencies success',
  SetError = "[Package visualizer] Set error",
}

export class GetPackageSummary implements Action {
  public readonly type = EPackageSummaryActions.GetPackageSummary;
  constructor(public payload: { packageId: Guid, packageName: string }) {} // The payload is the guid of the uploaded bex package
}

export class GetPackageSummarySuccess implements Action {
  public readonly type = EPackageSummaryActions.GetPackageSummarySuccess;
  constructor(public payload: IPackageSummary) {}
}

export class GetPackageSummaryFailure implements Action {
  public readonly type = EPackageSummaryActions.GetPackageSummaryFailure;
  constructor() {}
}

export class SetSelectedCatalogObjects implements Action {
  public readonly type = EPackageSummaryActions.SetSelectedCatalogObjects;
  constructor(public payload?: string) {}
}

export class SearchAndFilterPackageSummary implements Action {
  public readonly type = EPackageSummaryActions.SearchAndFilterPackageSummary;
  constructor() {} // The payload is the selected filters array
}

export class SetSearchText implements Action {
  public readonly type = EPackageSummaryActions.SetSearchText;
  constructor(public payload: string) {} // The payload is the selected filters array
}

export class SetSelectedFilters implements Action {
  public readonly type = EPackageSummaryActions.SetSelectedFilters;
  constructor(public payload: Array<string>) {} // The payload is the selected filters array
}

export class GetDependencies implements Action {
  public readonly type = EPackageSummaryActions.GetDependencies;
  constructor(public payload: string) {} // The payload is the CatalogObject id
}

export class GetDependenciesSuccess implements Action {
  public readonly type = EPackageSummaryActions.GetDependenciesSuccess;
  constructor(public payload: IPackageDependencies) {} // The payload are the dependencies
}

export class SetError implements Action {
  public readonly type = EPackageSummaryActions.SetError;
  constructor(public payload: boolean) {}
}

export type PackageSummaryActions =
  | GetPackageSummary
  | GetPackageSummarySuccess
  | GetPackageSummaryFailure
  | SetSelectedCatalogObjects
  | SearchAndFilterPackageSummary
  | SetSearchText
  | SetSelectedFilters
  | GetDependencies
  | GetDependenciesSuccess
  | SetError;
